var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9059_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0623 29.0871H32.0435V14.2985H36.9999L18.5 0.730469L0 14.2985H4.95647V29.0871H2.9376C1.76734 29.0871 0.815421 30.0391 0.815421 31.2093V36.2694H36.1844V31.2093C36.1845 30.0391 35.2326 29.0871 34.0623 29.0871ZM4.32094 12.8838L18.5 2.48517L32.6791 12.8838H4.32094ZM30.6287 14.2985V29.0871H26.9091V14.2985H30.6287ZM25.4944 14.2985V29.0871H21.7748V14.2985H25.4944ZM20.3599 14.2985V29.0871H16.6403V14.2985H20.3599ZM15.2256 14.2985V29.0871H11.5056V14.2985H15.2256ZM10.0909 14.2985V29.0871H6.37128V14.2985H10.0909ZM34.7697 34.8547H2.23023V31.2093C2.23023 30.819 2.54763 30.502 2.9376 30.502H34.0623C34.4523 30.502 34.7697 30.8191 34.7697 31.2093V34.8547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.77063C16.9074 5.77063 15.6114 7.05756 15.6114 8.63883C15.6114 10.2201 16.9073 11.507 18.5 11.507C20.0927 11.507 21.3886 10.2201 21.3886 8.63883C21.3886 7.05763 20.0926 5.77063 18.5 5.77063ZM18.5 10.0923C17.6872 10.0923 17.0262 9.44017 17.0262 8.63883C17.0262 7.83749 17.6873 7.18537 18.5 7.18537C19.3128 7.18537 19.9738 7.83749 19.9738 8.63883C19.9738 9.44017 19.3127 10.0923 18.5 10.0923Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9059_2056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.f28f77134212a43e5442864b006645a9.svg";
export { ForwardRef as ReactComponent };